'use client';

export const TickerLogo = ({
  size = 20,
  src,
  symbol,
  tone = 'light',
}: {
  size?: number;
  src?: string | null;
  symbol: string;
  tone?: 'light' | 'dark';
}) => {
  const letter = symbol.trim().charAt(0).toUpperCase() || '?';
  const isDark = tone === 'dark';

  return (
    <span
      aria-hidden
      className={`flex shrink-0 items-center justify-center overflow-hidden ${
        isDark ? 'bg-bzblue-1000 outline-white/10' : 'bg-white outline-black/10'
      } outline outline-1`}
      style={{ borderRadius: 5, height: size, width: size }}
    >
      {src ? (
        <img alt="" className="max-h-full max-w-full object-contain" src={src} />
      ) : (
        <span className={`text-[10px] font-bold leading-none ${isDark ? 'text-white' : 'text-bzblue-800'}`}>
          {letter}
        </span>
      )}
    </span>
  );
};

export const TickerIdentity = ({
  logo,
  name,
  size = 20,
  symbol,
  tone = 'light',
}: {
  logo?: string | null;
  name?: string | null;
  size?: number;
  symbol: string;
  tone?: 'light' | 'dark';
}) => {
  const symbolClass = tone === 'dark' ? 'text-[#F2F8FF]' : 'text-bzblue-900';
  const nameClass = tone === 'dark' ? 'text-[#99AECC]' : 'text-slate-500';

  return (
    <span className="flex min-w-0 items-center gap-2">
      <TickerLogo size={size} src={logo} symbol={symbol} tone={tone} />
      <span className="min-w-0">
        <span className={`block truncate text-sm font-extrabold ${symbolClass}`}>{symbol}</span>
        {name ? <span className={`block truncate text-xs ${nameClass}`}>{name}</span> : null}
      </span>
    </span>
  );
};
